import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  filters: {
    selectedProject: [],
    projectType: '',
    selectedType: '',
    selectedCategory: [],
    selectedDueDate: '',
    selectedOwner: '',
    pageSize: 10,
    currentPage: 1,
    totalPages: 1,
    goToPage: 1,
    totalRecords: 1,
    inputValue: '',
  },
  prevFilters: {
    selectedProject: [],
    projectType: '',
    selectedType: '',
    selectedCategory: [],
    selectedDueDate: '',
    selectedOwner: '',
    pageSize: 10,
    currentPage: 1,
    totalPages: 1,
    goToPage: 1,
    totalRecords: 1,
    inputValue: '',
  },
}

export const rfxFilterValuesSlice = createSlice({
  name: 'set-rfx-filter-values',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      }
    },
    setPrevFilters: (state, action) => {
      state.prevFilters = JSON.parse(JSON.stringify(action.payload))
    },
    resetFilters: (state) => {
      state.filters = initialState.filters
    },
  },
})

export const { setFilters, resetFilters, setPrevFilters } = rfxFilterValuesSlice.actions

export default rfxFilterValuesSlice.reducer
